var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApproveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 90,
    viewBox: "0 0 201 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 112.829,
    width: 32.8767,
    height: 8.18182,
    rx: 4.09091,
    fill: "#F0F5FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 112.829,
    y: 16.3633,
    width: 52.0548,
    height: 8.18182,
    rx: 4.09091,
    fill: "#F0F5FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 151.185,
    y: 2.72656,
    width: 13.6986,
    height: 8.18182,
    rx: 4.09091,
    fill: "#F0F5FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 186.801,
    y: 38.1816,
    width: 13.6986,
    height: 8.18182,
    rx: 4.09091,
    fill: "#F0F5FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 126.527,
    y: 35.4551,
    width: 54.7945,
    height: 8.18182,
    rx: 4.09091,
    fill: "#F0F5FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 126.527,
    y: 54.5449,
    width: 41.0959,
    height: 8.18182,
    rx: 4.09091,
    fill: "#F0F5FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 25.1577,
    y: 54.5449,
    width: 49.3151,
    height: 8.18182,
    rx: 4.09091,
    fill: "#F0F5FF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 73.6367,
    width: 84.9315,
    height: 8.18182,
    rx: 4.09091,
    fill: "#F0F5FF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.4726,
    cy: 16.3627,
    rx: 5.47945,
    ry: 5.45455,
    fill: "#F0F5FF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 142.966,
    cy: 70.9096,
    rx: 5.47945,
    ry: 5.45454,
    fill: "#F0F5FF"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 184.061,
    cy: 27.2722,
    rx: 2.73972,
    ry: 2.72727,
    fill: "#F0F5FF"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.87,
    cy: 51.8185,
    rx: 38.3562,
    ry: 38.1818,
    fill: "#F0F5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.094 48.7725V50.135C117.093 53.3287 116.054 56.4362 114.133 58.9942C112.212 61.5521 109.512 63.4234 106.435 64.3289C103.358 65.2344 100.07 65.1257 97.0607 64.0189C94.0512 62.9121 91.4818 60.8666 89.7356 58.1874C87.9894 55.5082 87.16 52.3388 87.3711 49.1521C87.5822 45.9653 88.8225 42.9318 90.907 40.5041C92.9915 38.0763 95.8085 36.3844 98.9378 35.6805C102.067 34.9767 105.341 35.2987 108.272 36.5986M117.094 38.2869L102.217 53.1118L97.7533 48.6688",
    stroke: "#0A5EF3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveIcon);
export default __webpack_public_path__ + "static/media/approve-icon.b03ac1e13a8d0fd192928567fd815480.svg";
export { ForwardRef as ReactComponent };